import { fetchGet } from './api';
import { IReason } from '../types/reason.type';

export const fetchReasons = () => fetchGet<IReason[]>('reasons');
